/**
 * Which platform blocks this theme restyles, and how wide each one sits.
 *
 * <p><strong>This data lives outside `withKitchenSkin.tsx` on purpose, and the
 * reason is a build failure rather than tidiness.</strong> That file carries
 * `'use client'`, and every export of a client module reaches a server module
 * as a *reference* rather than as the value itself. The theme bundle in
 * `../index.ts` is evaluated wherever the theme is imported — including from
 * the server, through `app/api/storefront/extensions/[...path]/route.ts`,
 * which pulls the extensions module in to read its API prefixes. Reading this
 * map there has to see real data, so the map cannot be declared behind the
 * client boundary.
 *
 * <p>Keeping it here also keeps it testable from anywhere: `templates`'
 * seed test asserts every functional block a required page uses appears in
 * this map, and that test is not a React environment.
 */

/** How wide the functional content sits. Forms read best narrow; baskets need room. */
export type SkinWidth = 'narrow' | 'medium' | 'wide';

/**
 * The platform blocks this theme restyles, with the width each sits at.
 * Every page the storefront requires uses one of these for its functional part.
 */
export const SKINNED_BLOCKS: Record<string, SkinWidth> = {
  CartView: 'medium',
  CheckoutForm: 'medium',
  OrderConfirmation: 'medium',
  OrderTracking: 'narrow',
  StoreLocator: 'medium',
  AccountDashboard: 'medium',
  AccountOrderDetail: 'medium',
  SignInForm: 'narrow',
  RegisterForm: 'narrow',
  TradeApplicationForm: 'medium',
  InstallerApplicationForm: 'medium',
  InstallerDocuments: 'medium',
  ForgotPasswordForm: 'narrow',
  ResetPasswordForm: 'narrow',
  ProductGrid: 'wide',
  FacetPanel: 'wide',
  RichText: 'medium',
  FaqAccordion: 'medium',
  DynamicFormBlock: 'narrow',
};
